import { CustomModelAutomaticMutationSideEffectConfigs } from "../types";

export const MANAGED_CONTENT_RECORD_ASSIGNMENTS_MUTATION_SIDE_EFFECT_CONFIGS: CustomModelAutomaticMutationSideEffectConfigs<"managed_content_record_assignments"> =
  {};
